//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "Footer",
  data() {
    return {
      title: "Footer",
      version: "1.0",
      acc_plan: "FREE",
      date_exire: "",
      checklanguage:"",
      checklogin:false,
    };
  },
   async mounted() {
    // this.checklogin = api.isLoggedIn();
  },
    computed: {
    },
  methods: {
  },
  async beforeCreate() {
  },
};
